import { Shadow, SkeletonTypes, HStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { LateralBar } from '../LateralBar';

export const CardLoadingItemDesktop: React.FC = () => {
  const ColoredSkeleton = (props: SkeletonTypes.Props) => (
    <Skeleton {...props} endColor="brand.primary.lightest" />
  );

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} p="25px">
      <LateralBar
        backgroundColor="brand.primary.lightest"
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <HStack justifyContent="space-between" alignItems="center" w="full">
        <ColoredSkeleton width="20%" height="20px" rounded="full" />

        <HStack justifyContent="space-between" space={Spacing['inline.xxs']} width="300px">
          <HStack space={Spacing['inline.nano']} alignItems="center" width="100%">
            <ColoredSkeleton width="33%" height="20px" rounded="full" />
            <ColoredSkeleton width="33%" height="20px" rounded="full" />
            <ColoredSkeleton width="33%" height="20px" rounded="full" />
          </HStack>
        </HStack>
      </HStack>
    </Shadow>
  );
};
